import ajax from 'libraries/ajax'
import base from 'components/base'
import componentInit from 'components/componentInit'
import dialog from 'components/dialog'
import $ from 'jquery'

class lukukuumeForm extends base
{
  elements = {
    form: null,
    openDialogLabel: null,
    openDialogLink: null
  }

  constructor(element)
  {
    super()

    this.elements.form = $(element).get(0)
    this.elements.openDialogLabel = $(this.elements.form).find('.dialog-label .option label').get(0)

    this.createDialogOpenLink()
    this.bindEvents()
  }

  createDialogOpenLink()
  {
    let matches = $(this.elements.openDialogLabel).text().match(/^(.*?)(\S+\s+\S+)$/)
    if(matches && matches[1] && matches[2])
    {
      this.elements.openDialogLink = $('<a class="open-dialog" href="">'+ matches[2] +'</a>').get(0)
      $(this.elements.openDialogLabel).html(matches[1]).append(this.elements.openDialogLink)
    }
  }

  bindEvents()
  {
    if(this.elements.openDialogLink)
    {
      let dialogElement = $('.dialog').get(0)
      if(dialogElement)
        new dialog(dialogElement, this.elements.openDialogLink)
    }
  }
}

componentInit.prototype.callbacks[module.id] = (parentElement) =>
{
  let elements = $(parentElement).find('form.lukukuume').get()
  for(let element of elements)
    new lukukuumeForm(element)
}

ajax.query.prototype.events.onSuccess.push((query) => {
  if(query.parameters.element && $(query.parameters.element).is('form.lukukuume'))
    $('#site-content').find('main.content').children().not('.form, .keep').remove()
})

export default lukukuumeForm



// WEBPACK FOOTER //
// ./applications/publicFrontend/scripts/components/lukukuumeForm.js